import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PageHeading from './LayoutComponents/PageHeading'

const DeleteModal = ({ modal, toggleModal, handleDeleteCompany, name, id }) => {
  return (
    <Modal isOpen={modal} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>
        <PageHeading small>Confirm Delete</PageHeading>
      </ModalHeader>
      <ModalBody>Are you sure you want to delete {name}?</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          Cancel
        </Button>{' '}
        <Button color="danger" onClick={() => handleDeleteCompany(id)}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DeleteModal
